<h2 class="dialog-title">{{'modal.matrix.edit' | transloco}} {{header | transloco}}</h2>
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css">

<app-drake-view-standard [viewConfig]="viewConfig"
                         [baseData]="baseData"
                         [readonly]="readonly"
                         [matrix]="true"
                         (fieldValueChanged)="onChange($event)">
</app-drake-view-standard>

<div *ngIf="!viewConfig">
  <p>Errore: configurazione non disponibile</p>
</div>

<div class="dialog-actions">
    <button (click)="onNoClick()" class="dialog-button cancel-button">
        <span class="fas fa-trash"></span> {{'modal.matrix.cancel' | transloco}} <span></span>
    </button>
    <span></span>
    <button (click)="onSaveClick()" class="dialog-button save-button">
        <span class="fas fa-save"></span> {{'modal.matrix.save' | transloco}} <span></span>
    </button>
</div>

<div *ngIf="false">{{baseData | json}}</div>
